// extracted by mini-css-extract-plugin
module.exports = {"classList":"l7QV8","sectionTitle":"_2ows_","spellsImg":"_3kv2d","spellsCard":"_1gxi1","classCard":"arG0W","title":"_2EafU","avatar":"_1Z-xH","cardBg":"_3LY7y"};